import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "user-login__right" }

import { ref, computed } from 'vue';

import { APP_NAME } from '../constants/index';

import LoginRegister from '../components/login-register.vue';
import LoginSetpwd from '../components/login-setpwd.vue';
import LoginMain from '../components/login-main.vue';
import LoginForget from '../components/login-forget.vue';
import LoginReset from '../components/login-reset.vue';
import LoginSuccess from '../components/login-success.vue';
import { PLATFORM_IMAGES } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const COMPONENT_MAPPING = {
  // 右侧 注册
  'login-register': LoginRegister,
  // 右侧 注册-设置登录密码
  'login-setpwd': LoginSetpwd,
  // 右侧 登录
  'login-main': LoginMain,
  // 忘记密码  先验证手机号
  'login-forget': LoginForget,
  // 忘记密码  重置密码
  'login-reset': LoginReset,
  // 重置成功
  'login-success': LoginSuccess
  // [LoginSuccess.__name]: LoginSuccess  类型无法识别
};

const componentName = ref<keyof typeof COMPONENT_MAPPING>('login-main');

const currentComponent = computed(() => {
  return COMPONENT_MAPPING[componentName.value];
});
const title = computed(() => {
  return componentName.value === 'login-success' ? '重置密码成功' : APP_NAME;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "user-login",
    style: _normalizeStyle({
      background: `url(${_unref(PLATFORM_IMAGES)['login_bg']})`,
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat'
    })
  }, [
    _createElementVNode("img", {
      class: "user-login__logo",
      src: _unref(PLATFORM_IMAGES)['logo']
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "user-login__title",
        style: _normalizeStyle({
          textAlign: componentName.value === 'login-success' ? 'center' : 'left'
        })
      }, _toDisplayString(title.value), 5),
      (_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), {
        modelValue: componentName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((componentName).value = $event))
      }, null, 8, ["modelValue"]))
    ])
  ], 4))
}
}

})